import { slugify } from './slugify';
import { getPluralProductName } from './getPluralProductName';

export const getCategory = product => product.split(',').length > 1 ? 'day-passes' : slugify(getPluralProductName(product, 2));
